
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { RmrkType } from '@/components/rmrk/service/scheme'
import {
  INFINITE_SCROLL_CONTAINER_ID,
  INFINITE_SCROLL_ITEM_CLASS_NAME,
} from '~/utils/mixins/infiniteScrollMixin'
import { usePreferencesStore } from '@/stores/preferences'

const components = {
  GalleryCard: () => import('./GalleryCard.vue'),
  Layout: () => import('./Layout.vue'),
}

@Component({ components })
export default class GalleryCardList extends Vue {
  @Prop({ default: '/rmrk/gallery' }) public route!: string
  @Prop({ default: 'rmrk/gallery' }) public link!: string
  @Prop() public items!: RmrkType[]
  @Prop(Boolean) public horizontalLayout!: boolean
  @Prop(Boolean) public listed!: boolean
  protected scrollContainerId = INFINITE_SCROLL_CONTAINER_ID
  protected scrollItemClassName = INFINITE_SCROLL_ITEM_CLASS_NAME
  private preferencesStore = usePreferencesStore()

  get classLayout() {
    return this.preferencesStore.getLayoutClass
  }

  protected metadataOf(nft: any) {
    return nft.metadata || nft.collection?.metadata
  }
}
